<div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start stretch">
  <mat-card
    *ngFor="let shareholder of shareholders; let i = index"
    fxLayout="row"
    fxLayoutAlign="stretch center"
    fxLayoutGap="30px"
  >
    <h3 class="rm-margin">{{ i + 1 }}</h3>

    <h3 fxFlex class="rm-margin" >{{ shareholder?.shareholderName }}</h3>

    <span >{{shareholder?.file?.name}}</span>

    <button type="button" mat-icon-button (click)="downloadFile(shareholder.file)">
      <mat-icon>download</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      (click)="deleteShareholder(shareholder.id)"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-card>



  <div class="" *ngIf="shareholders?.length < 4" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
    <mat-form-field appearance="outline">
      <mat-label>{{ "SHAREHOLDERS_NAME" | translate }}</mat-label>
      <input
        [formControl]="newShareholderNameInput"
        matInput
        [placeholder]="'SHAREHOLDERS_NAME' | translate"
      />
    </mat-form-field>
    <button type="button" (click)="inputFile.click()" mat-icon-button>
      <mat-icon>upload</mat-icon>
    </button>

    <mat-spinner *ngIf="uploading" diameter="30"></mat-spinner>

    <span fxFlex>{{currentFileName}}</span>
    <input
      type="file"
      #inputFile
      id="input-file"
      (change)="uploadShareholderFile($event)"
    />

    <button [disabled]="uploading" mat-flat-button color="primary" class="my-button" type="button" (click)="addShareholder()">
      {{ "ADD" | translate }}
    </button>
  </div>
</div>
